module.exports = ".btn-file {\n  position: relative;\n  overflow: hidden; }\n\n.btn-file input[type=file] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  min-width: 100%;\n  min-height: 100%;\n  font-size: 100px;\n  text-align: right;\n  filter: alpha(opacity=0);\n  opacity: 0;\n  outline: none;\n  background: white;\n  cursor: inherit;\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/worker/worker-header/worker-header.component.scss
// module id = ./src/app/worker/worker-header/worker-header.component.scss
// module chunks = main